import { InstitutionsAuthorizationService } from "@/features/accounts/shared/services/institutions-authorization-service";
import { RegisterPaymentApiAccountsService } from "@/features/accounts/payment/api/services/register-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";
import { ErrorDialogContext, errorHandledAsync } from "@/shared/context/error-context";
import { MoneyLinkWarning } from "@/shared/utils/custom-exception";


export const useInstitutionsAuthorization = () => {
  const {
    authType,
    selectedInstitutionService,
  } = useInstitutionsContext();
  const { selectedAccountGroup } = useAccountGroupsContext();

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);
  // エラーダイアログ用コンテキスト
  const { setError } = useContext(ErrorDialogContext);
  const registerPaymentApiAccountsService = new RegisterPaymentApiAccountsService();
  const institutionsAuthorizationService = new InstitutionsAuthorizationService();

  /*--------------------
    イベント関連
  --------------------*/
  // 金融機関サイト認可画面要求
  const requestInstitutionsAuthorizationSite = async () => {
    loadingCtx.setIsLoading(true);
    try {
      if (!selectedInstitutionService) {
        setError(new MoneyLinkWarning({
          title: "予期せぬエラー",
          message: "サービスが選択されていません。"
        }));
        return;
      }
      let res;
      // LookAPI版口座
      if (authType === "crecaLookApi" || authType === "emoneyLookApi") {
        res =  await registerPaymentApiAccountsService.registerPaymentApiAccounts({
          account_group_id: selectedAccountGroup.accountGroupId,
          industry_code: selectedInstitutionService.industryCode,
          company_code: selectedInstitutionService.companyCode,
          service_code: selectedInstitutionService.serviceCode,
          ...(selectedInstitutionService.companyName !== "" && { institution_name: selectedInstitutionService.companyName }),
        });
      }
      // その他(銀行API、クレカAPI、ECショップ)
      else if (authType === "bank" || authType === "crecaApi" || authType === "ecshop") {
        res = await institutionsAuthorizationService.getInstitutionsAuthorization({
          account_group_id: selectedAccountGroup.accountGroupId,
          industry_code: selectedInstitutionService.industryCode,
          company_code: selectedInstitutionService.companyCode,
          service_code: selectedInstitutionService.serviceCode,
          ...(selectedInstitutionService.branchCode !== "" && { branch_code: selectedInstitutionService.branchCode }),
        });
      }
      // 許可しない動き
      else {
        setError(new MoneyLinkWarning({
          title: "予期せぬエラー",
          message: "不正な認可タイプです。"
        }));
        return;
      }

      if (res.redirect_url) {
        window.location.href = res.redirect_url;
      }
    } catch (error) {
      // エラーハンドリング：モーダルを閉じずにエラーダイアログを表示
      console.log("requestInstitutionsAuthorizationSite:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    requestInstitutionsAuthorizationSite: errorHandledAsync(requestInstitutionsAuthorizationSite, setError),
  };
};
